import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Bookmark } from 'react-feather';
import Macy from 'macy';

const Grid = styled.div`
  justify-content: space-between;
`;

const CardLink = styled.a`
  cursor: pointer;
`;

const CardWrapper = styled.div`
  width: 100%;
`;

const CardImageWrapper = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  margin-bottom: 24px;
`;

const CardImage = styled.img`
  width: 100%;
  height: auto;
  position: relative;
  margin-bottom: 24px;
`;

const CardPrice = styled.div`
  position: absolute;
  bottom: 16px;
  right: 0;
  background-color: var(--btn-bkc);
  border: 1px solid var(--btn-border-bkc);
  font-size: 12px;
  padding: 8px 7px;
  z-index: var(--zIndexCtaContent);
`;

const CardContent = styled.div`
  width: 100%;
  justify-content: space-between;
  display: flex;
`;

const CardContentLeft = styled.div`
  padding: 0 16px;
  flex-shrink: 0;
  cursor: pointer;
`;

const CardContentCentre = styled.div`

`;

const CardContentRight = styled.div`
  padding: 0 16px;
  flex-shrink: 0;
  cursor: pointer;
`;

const ColorSwatch = styled.div`
  width: 24px;
  height: 24px;
`;

const Placeholder = styled.div`
  width: 24px;
  height: 24px;
`;

const CardContentTitle = styled.div`
  font-size: 16px;
  text-align: center;
`;

const CardContentSubtitle = styled.div`
  font-size: 16px;
  text-align: center;
  color: var(--subtitle-color);
`;

const ProductCard = ({ item, shopifyId, onRemove }) => {
  const [isLoading, setLoading] = useState(false);

  let colorSwatch = false
  let price = 99999999

  if (item.options_with_values) {
    item.options_with_values.forEach(o => {
      if (o.values.size > 1 && o.name != 'Colour Temp' && o.name == 'Size' || o.name.includes('Colour') || o.name.includes('Finish')) {
        colorSwatch = true
      }
    })
  }

  if (item.variants) {
    item.variants.forEach(v => {
      if (price > v.price && v.price > 0) {
        price = v.price
      }
    })
  }

  const removeProductFromWishlist = () => {
    window.theme.ENV.apiUrl + '/wishlist?site=' + window.theme.wishlist.site + '&email=' + window.theme.wishlist.guestEmail

    const email = window.customer && window.customer.email;
    const guestID = window.theme.wishlist.guestEmail
    const url = window.theme.ENV.apiUrl + "/wishlist";

    const body = {
      productId: shopifyId,
      email: email || guestID,
      site: window.theme.wishlist.site
    };

    setLoading(true);

    return fetch(url, {
      method: "DELETE",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    })
      .then((result) => onRemove())
      .catch((error) => alert("An error occurred.\n\n" + error))
      .finally(() => setLoading(false));
  };

  const handleRemove = (e) => {
    e.stopPropagation()
    e.preventDefault()

    if (isLoading) return;
    if (!confirm("Remove product from wishlist?")) return;

    removeProductFromWishlist();
  };

  return (
    <CardLink href={`/collections/all/products/${item.handle}`}>
      <CardWrapper class="product__card">
        <CardImageWrapper class="product__card__image">
          {price > 0 && price !== '999999.00' && (
            <CardPrice class="product__card__price-label">
              {item?.variants?.length > 0 && "From $"}
              {price}
            </CardPrice>
          )}
          <CardImage class="product__card__image" src={item.image.src} />
        </CardImageWrapper>

        <CardContent class="product__card__content flex">
          <CardContentLeft class="product__card__content__left">
            {colorSwatch ? (
              <ColorSwatch src="{{ 'color.png' | asset_url }}" class="color-paint" />
            ) : (
                <Placeholder class="placeholder" />
              )}
          </CardContentLeft>
          <CardContentCentre class="product__card__content__center">
            <CardContentTitle class="product__card__content__title">{item.title} </CardContentTitle>

            <CardContentSubtitle class="product__card__content__subtitle">
              by {item.vendor}
            </CardContentSubtitle>
          </CardContentCentre>
          <CardContentRight class="product__card__content__right">
            <Bookmark onClick={handleRemove} width="24" stroke="var(--text-secondary-color)" fill="var(--text-third-color)" data-add-to-wishlist data-product-id={shopifyId} title="Bookmark this product" />
          </CardContentRight>
        </CardContent>
      </CardWrapper>
    </CardLink>
  )
}

const WishlistGrid = () => {
  const [isFetching, setFetching] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (window.theme) {
      if (window.theme.utils) {
        if (window.theme.utils.fetch) {

          fetchWishlist();
        }
      }
    }
  }, [window.theme.wishlist])

  const fetchWishlist = () => {
    setFetching(true);

    let url = window.theme.ENV.apiUrl + '/wishlist?site=' + window.theme.ENV.site + '&email='

    if (window?.customer && window?.customer?.email) {
      url += window.customer.email
    } else {
      url += window.theme.wishlist.guestEmail
    }

    window.theme.utils
      .fetch(url)
      .then((result) => {
        setData(result)
      })
      .catch((e) => {
        setError(e)
      })
      .finally(() => {
        setFetching(false)

        applyGridStyle();
      });
  };

  const applyGridStyle = () => {
    const macyInstance = Macy({
      container: ".collection__grid",
      columns: 4,
      margin: 40,
      breakAt: {
        600: 1,
        767: 2,
        1024: 3,
        1200: 4,
      },
    });
  }

  return (
    <div class="collection__container">
      <Grid className="collection__grid">
        {data?.products?.length > 0 ? (
          data.products.map((item) => <ProductCard item={item.shopifyData} id={item.id} shopifyId={item.shopifyId} onRemove={fetchWishlist} />)
        ) : isFetching ? (
          <div>Loading...</div>
        ) : error ? (
          <div>An error occurred. Please try again.</div>
        ) : (
                <div>No results were found matching that criteria.</div>
              )}
      </Grid>
    </div>
  );
};

export default WishlistGrid;